import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import { TextInputField, TextAreaField, RadioButtonField } from 'common/components/form_fields';

const Settings = ({ onSubmit, handleSubmit, invalid, participants }) => (
  <div className="tab-content settings">
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset>
        <h4>Focus Group Name</h4>
        <p>The name is only visible to you and your collaborators.</p>
        <div className="row">
          <div className="columns medium-8">
            <Field
              name="name"
              component={TextInputField}
              label="Group Name"
            />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <h4>Message to Participants</h4>
         <p>Let your participants know how they can help you. You can edit this later.</p>
        <Field
          name="purpose"
          component={TextAreaField}
        />
      </fieldset>
      {/* don't allow user to change whether votes should be weighted if FG already has
          participants */}
      { participants.length === 0 &&
      <fieldset>
        <h4>Weight Votes</h4>
        <p>Should certain participants&apos; votes count more than others?</p>
        <Field
          name="weight_votes"
          component={RadioButtonField}
          props={{ value: true }}
          label="Yes"
        />
        <Field
          name="weight_votes"
          component={RadioButtonField}
          props={{ value: false }}
          label="No"
        />
      </fieldset> }
      <fieldset>
        <h4>Share Results</h4>
        <p>Should participants to be able to see the results of the focus group after they
        participate?</p>
        <Field
          name="share_results"
          component={RadioButtonField}
          props={{ value: true }}
          label="Yes"
        />
        <Field
          name="share_results"
          component={RadioButtonField}
          props={{ value: false }}
          label="No"
        />
      </fieldset>
      <button type="submit" disabled={invalid} className="btn btn-primary">Save Settings</button>
    </form>
  </div>
);

Settings.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool,
};

export default Settings;



// WEBPACK FOOTER //
// ./focus_groups/components/settings.jsx